<template>
  <section>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card style="background-color: #f4f5fa;">
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>InBody</v-toolbar-title>
          <v-spacer></v-spacer>
        <!-- <v-toolbar-items>
          <v-btn
            dark
            text
            @click="handleDiary"
          >
            Save
          </v-btn>
        </v-toolbar-items> -->
        </v-toolbar>
        <div>
          <center class="pt-2">
            <v-icon
       
            v-show="CheckPrev(record, inBodyRecordList)"
            @click="prev">
              mdi-chevron-double-left
            </v-icon>

            <span class=" pl-5 pr-5"><span class="summary-day">Test Date / Time </span> {{  moment(record.testDateTime, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm')}}
            </span>
            <!-- v-show="inBodyRecordList.length" -->
            <v-icon
            v-show="CheckNext(record, inBodyRecordList)"

             @click="next">
              mdi-chevron-double-right
            </v-icon>
          </center>
          <section class="pl-2 pr-2 pt-2 scroll-list "    :style="{ height: nodeHeight }">
            <v-card
              rounded-lg
              class="mb-3"
            >
              <!-- <v-icon
                class="abs-icon "
                @click="handleChartNav('workType')"
              >
                mdi-chevron-double-right
              </v-icon> -->
              <div class="pl-2 pr-2 pt-2 pb-2 label-title">
                <span class="text-bold font-italic">
                  <span >Weight Control</span>
                </span>
                <v-row no-gutters>
                  <v-col cols="3">
                    <div class="label-blue content-text text-center">
                      Target Weight
                    </div>
                    <div class="content-text text-center">

                      <span class="font-italic label-black "  style="font-size:1.5rem;color:black"> {{record.targetWeight}} </span>
                      <span class="font-italic label-small"> kg</span>

                    </div>
                  </v-col>
                  <v-col cols="3" >
                    <div class="content-text text-center"  style="color:#12CDD4">
                      Weight Control
                    </div>
                    <div class="content-text text-center mt-2" >
                      <span class="font-italic label-black "  style="font-size:1rem;color:black"> {{record.weightControl}} </span>
                      <span class="font-italic label-small"> kg</span>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="content-text text-center" style="color:#F35233">
                      Fat Control
                    </div>
                    <div class="content-text text-center mt-2">
                      <span class="font-italic label-black "  style="font-size:1rem;color:black">  {{ record.bfmControl }} </span>
                      <span class="font-italic label-small"> kg</span>
                    </div>
                  </v-col>
                  <v-col cols="3">
                    <div class="content-text text-center" style="color:#571F1F">
                      Muscle Control
                    </div>
                    <div class="content-text text-center mt-2">
                      <span class="font-italic label-black "  style="font-size:1rem;color:black">   {{ record.ffmControl }} </span>
                      <span class="font-italic label-small"> kg</span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <v-card
              rounded-lg
              class="mb-3"
            >
              <div class="pl-2 pr-2 pt-2 pb-2 label-title">
                <div class="text-bold font-italic">
                  <div>Body Composition Analysis</div>

                </div>
                <!-- v-for"item in BCAArray" -->
                <v-row v-for="item in BCAArray" no-gutters>
                  <v-col cols="6">
                    <div class="label-black " style="font-size:1.2rem">
                      {{item.title}}
                    </div>
                    <div class="content-text label-gray"  >
                    {{item.subTitle}}
                    </div>
                  </v-col>
                  <v-col  cols="3" class="mt-2">
                  <span class="label-black" style="font-size:0.8rem" >
                    ({{item.range}})
                  </span>
                  </v-col>
                  <v-col class="mt-0 text-right">
                   <span   class="label-black" style="font-size:1.4rem">{{item.value }}</span>
                   <span class="font-italic label-small label-gray ">    {{item.unit}}</span>
                  </v-col>
                </v-row>

              </div>
            </v-card>


            <v-card
            rounded-lg
            class="mb-3"
          >
            <div class="pl-2 pr-2 pt-2 pb-2 label-title">
              <div class="text-bold font-italic">
                <div>Muscle-Fat Analysis</div>
              </div>
              <v-row v-for="item in MFAArray" no-gutters>
                <v-col cols="7">
                  <div class="label-black " style="font-size:1.2rem">
                    {{item.title}}
                  </div>
                  <div class="content-text label-gray"  >
                  {{item.subTitle}}
                  </div>
                </v-col>
                <v-col cols="4" class="mt-0">
                 <span   class="label-black" style="font-size:1.4rem">{{item.value }}</span>
                 <span class="font-italic label-small label-gray ">    {{item.unit}}({{item.percentage}})</span>
                </v-col>
                <v-col  class="mt-2">
                  <v-icon
                  small
                  right
                  :color="item.iconStyle"

                >
              {{ item.icon }}
                </v-icon>
                </v-col>
              </v-row>
            </div>
          </v-card>


          <v-card
          rounded-lg
          class="mb-3"
        >
          <div class="pl-2 pr-2 pt-2 pb-2 label-title">
            <div class="text-bold font-italic">
              <div>Obesity Analysis</div>
            </div>
            <v-row v-for="item in OAArray" no-gutters>
              <v-col cols="7">
                <div class="label-black " style="font-size:1.2rem">
                  {{item.title}}
                </div>
                <div class="content-text label-gray"  >
                {{item.subTitle}}
                </div>
              </v-col>
              <v-col cols="4" class="mt-0" >
               <span   class="label-black" style="font-size:1.4rem">{{  item.value  }}</span>
               <span class="font-italic label-small label-gray ">    {{item.unit}}</span>
              </v-col>
              <v-col  class="mt-2">
                <v-icon
                small
                right
                :color="item.iconStyle"
              >
            {{ item.icon }}
              </v-icon>
              </v-col>
            </v-row>
          </div>
        </v-card>

        <v-card
        rounded-lg
        class="mb-3"
      >
        <div class="pl-2 pr-2 pt-2 pb-2 label-title">
          <div class="text-bold font-italic">
            <div>Segmental Lean Analysis</div>
          </div>
          <v-row v-for="item in SLAArray" no-gutters>
            <v-col cols="7">
              <div class="label-black " style="font-size:1.2rem">
                {{item.title}}
              </div>
              <div class="content-text label-gray"  >
              {{item.subTitle}}
              </div>
            </v-col>
            <v-col cols="4" class="mt-0" >
              <span   class="label-black" style="font-size:1.4rem">{{item.value}}</span>
              <span class="font-italic label-small label-gray ">    {{item.unit}}({{item.percentage}})</span>
            </v-col>
            <v-col  class="mt-2">
              <v-icon
              small
              right
              :color="item.iconStyle"
            >
          {{ item.icon }}
            </v-icon>
            </v-col>
          </v-row>
        </div>
      </v-card>


      <v-card
      rounded-lg
      class="mb-3"
    >
      <div class="pl-2 pr-2 pt-2 pb-2 label-title">
        <div class="text-bold font-italic">
          <div>Segmental Fat Analysis</div>
        </div>
        <v-row v-for="item in SFAArray" no-gutters>
          <v-col cols="7">
            <div class="label-black " style="font-size:1.2rem">
              {{item.title}}
            </div>
            <div class="content-text label-gray"  >
            {{item.subTitle}}
            </div>
          </v-col>
          <v-col cols="4" class="mt-0" >
            <span   class="label-black" style="font-size:1.4rem">{{item.value}}</span>
            <span class="font-italic label-small label-gray ">    {{item.unit}}({{item.percentage}})</span>
          </v-col>
          <v-col  class="mt-2">
            <v-icon
            small
            right
            :color="item.iconStyle"
          >
        {{ item.icon }}
          </v-icon>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-card
    rounded-lg
    class="mb-3"
  >
    <div class="pl-2 pr-2 pt-2 pb-2 label-title">
      <div class="text-bold font-italic">
        <div>Research Paramters</div>

      </div>
      <v-row v-for="item in RPArray" no-gutters>
        <v-col cols="6">
          <div class="label-black " style="font-size:1.1rem">
            {{item.title}}
          </div>
        </v-col>
        <v-col  cols="3"  >
        <span class="label-black " style="font-size:0.8rem" >
          ({{item.range}})
        </span>
        </v-col>
        <v-col class="mt-0 text-right">
         <span   class="label-black" style="font-size:1.4rem">{{item.value }}</span>
         <span class="font-italic label-small label-gray ">    {{item.unit}}</span>
        </v-col>
      </v-row>
    </div>
  </v-card>

  <v-card
  rounded-lg
  class="mb-3"
>
  <div class="pl-2 pr-2 pt-2 pb-2 label-title">
    <div class="text-bold font-italic">
      <div>Impedance</div>
    </div>
    <v-row  no-gutters>
      <v-col cols="2"  >
        <div class="label-black " style="font-size:1.1rem">
        </div>
      </v-col>
      <v-col cols="2"  >
        <div class="label-gray " style="font-size:1.1rem">
          RA
        </div>
      </v-col>
      <v-col cols="2"  >
        <div class="label-gray " style="font-size:1.1rem">
          LA
        </div>
      </v-col>
      <v-col cols="2"  >
        <div class="label-gray " style="font-size:1.1rem">
          TR
        </div>
      </v-col>
      <v-col cols="2"  >
        <div class="label-gray " style="font-size:1.1rem">
          RL
        </div>
      </v-col>
      <v-col cols="1"  >
        <div class="label-gray" style="font-size:1.1rem">
          LL
        </div>
      </v-col>
    </v-row>
    <v-row  no-gutters>
      <v-col cols="2"  >
        <div class="label-black " style="font-size:0.9rem">
          Z(Ω) 20
          <span class="font-italic label-small label-gray "> kHz</span>
        </div>

      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black    " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz20RAImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex;  " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz20LAImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz20TRImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz20RLImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz20LLImpedance}}
        </div>
      </v-col>
    </v-row>

    <v-row  no-gutters>
      <v-col cols="2"  >
        <div class="label-black " style="font-size:0.9rem">
          100
          <span class="font-italic label-small label-gray "> kHz</span>
        </div>

      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz100RAImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz100LAImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz100TRImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz100RLImpedance}}
        </div>
      </v-col>
      <v-col cols="2" style="font-size:0.8rem ; display: flex; " >
        <div class="label-black  " style=" font-size:0.8rem ;align-items: center; display: flex;  ">
          {{record.kHz100LLImpedance}}
        </div>
      </v-col>
    </v-row>
  </div>
</v-card>


          </section>
        </div>
      </v-card>
    </v-dialog>
    <DiaryChart
      ref="diaryChart"
      v-model="diaryChartDialog"
      :record="record"
    >
    </DiaryChart>
  </section>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount , computed, watch, toRefs, nextTick } from 'vue'
import { getVuetify } from '@core/utils'
import { formatTime, formatDate, loading } from '@/utils/helper'
import DiaryChart from './DiaryChart.vue'

import { fetchCourseComment, fetchWorkoutType } from '@/api/courseComment'

import {
  listCourseItem,
  listAerobicItem,
} from '@/api/diaryRecord'

import { mdiChevronDoubleUp  , mdiChevronDoubleDown    , mdiEqual } from '@mdi/js';

import moment from '@/utils/moment'

const icon = {
Up : mdiChevronDoubleUp,
Equal : mdiEqual ,
Down : mdiChevronDoubleDown,

}
const nodeHeight = ref('0px')


function updateNodeHeight() { nodeHeight.value = `${window.innerHeight - 90}px` }


const diaryChart = ref(null)

const diaryChartDialog = ref(false)

const $vuetify = getVuetify()

function handleChartNav(target) {
  console.log('diaryChart.value', diaryChart.value)
  console.log('target', target)
  console.log('$vuetify', $vuetify)
  diaryChart.value.tab = 0
  diaryChartDialog.value = true

  diaryChart.value.goTo(target)

  // nextTick(() => {
  //   if (target === 'bodyWeight') {
  //     $vuetify.goTo(diaryChart.value.weeklyBodyWeightRef)
  //   } else if (target === 'dailyEvaluation') {
  //     $vuetify.goTo(diaryChart.value.weeklySleepRef)
  //   } else if (target === 'caloriesExpended') {
  //     $vuetify.goTo(diaryChart.value.weeklyCaloriesExpendedRef)
  //   } else if (target === 'trainingItem') {
  //     diaryChart.value.tab = 2
  //     $vuetify.goTo(diaryChart.value.trainingItemsRef)
  //   }
  // })
}

const courseCommentSelection = [...fetchCourseComment()]

function getCourseCommentDesc(id) {
  if (id > 0) {
    return courseCommentSelection.find(item => item.id === id).description
  }

  return ''
}

const courseItems = ref([])
listCourseItem({}).then(res => {
  courseItems.value = [...res.data.items]
})

const aerobicItems = ref([])
listAerobicItem({}).then(res => {
  aerobicItems.value = [...res.data.items]
})

function getAerobicItemDesc(id) {
  const aerobicItem = aerobicItems.value.find(item => item.id === id)
  if (aerobicItem) {
    return aerobicItem.description
  }

  return ''
}
function getCourseItemDesc(id) {
  const courseItem = courseItems.value.find(item => item.id === id)
  if (courseItem) {
    return courseItem.description
  }

  return ''
}

const workoutTypeSelection = [...fetchWorkoutType()]

function getWorkoutTypeDesc(id) {
  if (id > 0) {
    return workoutTypeSelection.find(item => item.id === id).description
  }

  return ''
}


function mapBACValue( BCAArray , record){

  for (let i = 0; i < BCAArray.length; i++) {
    if (BCAArray[i].title === 'Weight') {
    BCAArray[i].value = record.weight;
    BCAArray[i].range = `${record.lowerLimitWeightNormalRange} ~ ${record.upperLimitWeightNormalRange}`;
  }
  if (BCAArray[i].title === 'Total Body Water') {
    BCAArray[i].value = record.tbw;
    BCAArray[i].range = `${ record.lowerLimitTBWNormalRange } ~ ${ record.upperLimitTBWNormalRange}`;

  }
  if (BCAArray[i].title === 'Protein') {
    BCAArray[i].value = record.protein;
    BCAArray[i].range = `${ record.lowerLimitProteinNormalRange} ~ ${ record.upperLimitProteinNormalRange}`;

  }
  if (BCAArray[i].title === 'Minerals') {
    BCAArray[i].value = record.minerals;
    BCAArray[i].range = `${ record.lowerLimitMineralsNormalRange} ~ ${ record.upperLimitMineralsNormalRange}`;

  }
  if (BCAArray[i].title === 'Body Fat Mass') {
    BCAArray[i].value = record.bfm;
    BCAArray[i].range = `${ record.lowerLimitBFMNormalRange} ~ ${ record.upperLimitBFMNormalRange}`;
  }
}

  return BCAArray
}


function mapMFAValue( MFAArray , currentList , record){

const MFALength = MFAArray.length
const currentListLength = currentList.length
console.log('MFALength',MFALength)
console.log('record.id',record.id)
const index = currentList.findIndex(item => item.id == record.id);
console.log('indexrecord',index)

for (let i = 0; i < MFAArray.length; i++) {
  if (MFAArray[i].title === 'Weight') {
  MFAArray[i].value = record.weight;

  if (index < currentListLength - 1 ){
    console.log('parseFloat(currentList[index].weight',parseFloat(currentList[index].weight))
    console.log('parseFloat(currentList[index].weight',parseFloat(currentList[index + 1 ].weight))

    MFAArray[i].percentage =   ( 1 + (parseFloat(currentList[index].weight) - parseFloat(currentList[index+1].weight)) / parseFloat(currentList[index+1].weight) ) * 100  ;

    if (MFAArray[i].percentage == 100)
    {
      MFAArray[i].icon = icon.Equal
      MFAArray[i].iconStyle = colorStyle.blue
    }else if (MFAArray[i].percentage > 100){
      MFAArray[i].icon = icon.Up
      MFAArray[i].iconStyle = colorStyle.green

    }else{
      MFAArray[i].icon = icon.Down
      MFAArray[i].iconStyle = colorStyle.red
    }


    MFAArray[i].percentage = MFAArray[i].percentage.toFixed(2) + '%'


  }
  else{
    MFAArray[i].percentage = '100%'
    MFAArray[i].icon = icon.Equal
    MFAArray[i].iconStyle = icon.blue
  }

}
if (MFAArray[i].title === 'SMM') {
  MFAArray[i].value = record.smm;
  if (index < currentListLength - 1 ){

    MFAArray[i].percentage =   ( 1 + (parseFloat(currentList[index].smm) - parseFloat(currentList[index+1].smm)) / parseFloat(currentList[index+1].smm) ) * 100  ;
    // console.log('MFAArray[i].percentage',(parseFloat(currentList[index].smm) ) )
    if (MFAArray[i].percentage == 100)
    {
      MFAArray[i].icon = icon.Equal
      MFAArray[i].iconStyle = colorStyle.blue
    }else if (MFAArray[i].percentage > 100){
      MFAArray[i].icon = icon.Up
      MFAArray[i].iconStyle = colorStyle.green

    }else{
      MFAArray[i].icon = icon.Down
      MFAArray[i].iconStyle = colorStyle.red
    }
    MFAArray[i].percentage = MFAArray[i].percentage.toFixed(2) + '%'

  }
  else{
    MFAArray[i].percentage = '100%'
    MFAArray[i].iconStyle = icon.blue
    MFAArray[i].icon = colorStyle.Equal
  }


}
if (MFAArray[i].title === 'Body Fat Mass') {
  MFAArray[i].value = record.bfm;
  if (index < currentListLength - 1 ){
    MFAArray[i].percentage =   ( 1 + (parseFloat(currentList[index].bfm) - parseFloat(currentList[index+1].bfm)) / parseFloat(currentList[index+1].bfm) ) * 100  ;
    if (MFAArray[i].percentage == 100)
    {
      MFAArray[i].icon = icon.Equal
      MFAArray[i].iconStyle = colorStyle.blue
    }else if (MFAArray[i].percentage > 100){
      MFAArray[i].icon = icon.Up
      MFAArray[i].iconStyle = colorStyle.green

    }else{
      MFAArray[i].icon = icon.Down
      MFAArray[i].iconStyle = colorStyle.red
    }
    MFAArray[i].percentage = MFAArray[i].percentage.toFixed(2) + '%'
  }
  else{
    MFAArray[i].percentage = '100%'
    MFAArray[i].iconStyle = colorStyle.blue
    MFAArray[i].icon = icon.Equal
  }

}

}

return MFAArray
}



function  mapOAValue(OAArray , currentList , record){

const OALength = OAArray.length
console.log('OALength', OALength)
const currentListLength = currentList.length
const index = currentList.findIndex(item => item.id == record.id);

for (let i = 0; i < OAArray.length; i++) {
  console.log('OAArrayloop')
if (OAArray[i].title === 'BMI') {

OAArray[i].value = record.bmi;

if (index < currentListLength - 1 ){
  console.log('parseFloat(currentList[index].weight',parseFloat(currentList[index].bmi))
  console.log('parseFloat(currentList[index].weight',parseFloat(currentList[index + 1 ].bmi))

  OAArray[i].percentage =   ( 1 + (parseFloat(currentList[index].bmi) - parseFloat(currentList[index+1].bmi)) / parseFloat(currentList[index+1].bmi) ) * 100  ;

  if (OAArray[i].percentage == 100)
  {
    OAArray[i].icon = icon.Equal
    OAArray[i].iconStyle =  colorStyle.blue
  }else if (OAArray[i].percentage > 100){
    OAArray[i].icon = icon.Up
    OAArray[i].iconStyle =  colorStyle.green

  }else{
    OAArray[i].icon = icon.Down
    OAArray[i].iconStyle =  colorStyle.red
  }


  OAArray[i].percentage = OAArray[i].percentage.toFixed(2) + '%'


}
else{
  OAArray[i].percentage = '100%'
  OAArray[i].icon = icon.Equal
  OAArray[i].iconStyle =  colorStyle.blue
}

}
if (OAArray[i].title === 'PBF') {
OAArray[i].value = record.pbf;
if (index < currentListLength - 1 ){

  OAArray[i].percentage =   ( 1 + (parseFloat(currentList[index].pbf) - parseFloat(currentList[index+1].pbf)) / parseFloat(currentList[index+1].pbf) ) * 100  ;
  if (OAArray[i].percentage == 100)
  {
    OAArray[i].icon = icon.Equal
    OAArray[i].iconStyle =  colorStyle.blue
  }else if (OAArray[i].percentage > 100){
    OAArray[i].icon = icon.Up
    OAArray[i].iconStyle =  colorStyle.green

  }else{
    OAArray[i].icon = icon.Down
    OAArray[i].iconStyle =  colorStyle.red
  }


}
else{
  OAArray[i].percentage = '100%'
  OAArray[i].icon = icon.Equal
  OAArray[i].iconStyle =  colorStyle.blue
}


}
}


return OAArray


}


function  mapSLAValue(theArray ,  record){

const theLength = theArray.length
console.log('SLALength', theLength)


for (let i = 0; i < theArray.length; i++) {
  console.log('theArrayloop')
  if (theArray[i].title === 'Right Arm') {

 theArray[i].value = record.ffmOfRightArm;

   if (record.ffmPercentOfRightArm == 100)
   {
    console.log('theArray[i].ffmPercentOfRightArm == 100')
    theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.ffmPercentOfRightArm > 100){
    console.log('theArray[i].ffmPercentOfRightArm > 100')
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
    console.log('theArray[i].ffmPercentOfRightArm < 100')
    console.log('ddddd', theArray[i].ffmPercentOfRightArm )
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }

   theArray[i].percentage = record.ffmPercentOfRightArm.toFixed(2) + '%'


 }



 if (theArray[i].title === 'Left Arm') {
 theArray[i].value = record.ffmOfLeftArm;

   if (record.ffmPercentOfLeftArm == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.ffmPercentOfLeftArm > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }


   theArray[i].percentage = record.ffmPercentOfLeftArm.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Trunk') {
 theArray[i].value = record.ffmOfTrunk;


   if (record.ffmPercentOfTrunk == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.ffmPercentOfTrunk > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }


   theArray[i].percentage = record.ffmPercentOfTrunk.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Right Leg') {
 theArray[i].value = record.ffmOfRightLeg;


   if (record.ffmPercentOfRightLeg == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.fmPercentOfRightLeg > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }

   theArray[i].percentage = record.ffmPercentOfRightLeg.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Left Leg') {
 theArray[i].value = record.ffmOfLeftLeg;

   if (record.ffmPercentOfLeftLeg == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.ffmPercentOfLeftLeg > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }

   theArray[i].percentage = record.ffmPercentOfLeftLeg.toFixed(2) + '%'


 }

}

console.log('SLAArray' , theArray)
return theArray

}


function  mapSFAValue(theArray ,  record){

  for (let i = 0; i < theArray.length; i++) {
  console.log('theArrayloop')
  if (theArray[i].title === 'Right Arm') {

 theArray[i].value = record.bfmOfRightArm;


   if (record.bfmPercentOfRightArm == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.bfmPercentOfRightArm > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }



   theArray[i].percentage = record.bfmPercentOfRightArm.toFixed(2) + '%'


 }



 if (theArray[i].title === 'Left Arm') {
 theArray[i].value = record.bfmOfLeftArm;



   if (record.bfmPercentOfLeftArm == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.bfmPercentOfLeftArm > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }


   theArray[i].percentage = record.bfmPercentOfLeftArm.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Trunk') {
 theArray[i].value = record.bfmOfTrunk;


   if (record.bfmPercentOfTrunk == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.bfmPercentOfTrunk > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }

   theArray[i].percentage = record.bfmPercentOfTrunk.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Right Leg') {
 theArray[i].value = record.bfmOfRightLeg;

   if (record.bfmPercentOfRightLeg == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.bfmPercentOfRightLeg > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }




   theArray[i].percentage = record.bfmPercentOfRightLeg.toFixed(2) + '%'


 }

 if (theArray[i].title === 'Left Leg') {
 theArray[i].value = record.bfmOfLeftLeg;


   if (record.bfmPercentOfLeftLeg == 100)
   {
     theArray[i].icon = icon.Equal
     theArray[i].iconStyle = colorStyle.blue
   }else if (record.bfmPercentOfLeftLeg > 100){
     theArray[i].icon = icon.Up
     theArray[i].iconStyle = colorStyle.green
   }else{
     theArray[i].icon = icon.Down
     theArray[i].iconStyle = colorStyle.red
   }



   theArray[i].percentage = record.bfmPercentOfLeftLeg.toFixed(2) + '%'


 }

}

return theArray

}


function  mapIMValue(theArray ,  record){

 for (let i = 0; i < theArray.length; i++) {

 if (theArray[i].title === 'RA') {

theArray[i].valueFor20 = record.kHz20RAImpedance;
theArray[i].valueFor100 = record.kHz100RAImpedance;

}
if (theArray[i].title === 'LA') {

theArray[i].valueFor20 = record.kHz20LAImpedance;
theArray[i].valueFor100 = record.kHz100LAImpedance;

}
if (theArray[i].title === 'TR') {

theArray[i].valueFor20 = record.kHz20TRImpedance;
theArray[i].valueFor100 = record.kHz100TRImpedance;

}
if (theArray[i].title === 'RL') {

theArray[i].valueFor20 = record.kHz20RLImpedance;
theArray[i].valueFor100 = record.kHz100RLImpedance;

}

if (theArray[i].title === 'LL') {

theArray[i].valueFor20 = record.kHz20LLImpedance;
theArray[i].valueFor100 = record.kHz100LLImpedance;

}

}

return theArray

}

function  mapRPValue(theArray ,  record){

 for (let i = 0; i < theArray.length; i++) {

 if (theArray[i].title === 'Basal Metabolic Rate') {

theArray[i].value = record.bmr;
theArray[i].range = `${ record.lowerLimitBMRNormalRange } ~ ${ record.upperLimitBMRNormalRange}`;

}

if (theArray[i].title === 'Waist-Hi Ratio') {
  console.log('Waist-Hi Ratio',record.whr)
theArray[i].value = record.whr;
theArray[i].range = `${ record.lowerLimitWHRNormalRange } ~ ${ record.upperLimitWHRNormalRange}`;

}

if (theArray[i].title === 'Visceral Fat Level') {

theArray[i].value = record.vfl;
theArray[i].range = `1 ~ 9`;

}

if (theArray[i].title === 'Obesity Degree') {

theArray[i].value = record.obesityDegree;
theArray[i].range = `${ record.lowerLimitObesityDegreeNormalRange } ~ ${ record.upperLimitObesityDegreeNormalRange}`;

}

}

return theArray

}


const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  inBodyRecordList : {
    type: Array, // Update the type to Array
    default() {
      return [ ]
    },
    // default  () { return []} // Return an empty array as the default value
  },


  record: {
    type: Object,
    default() {
      return {
        userRecordID: 0,
        courseDate: '0001-01-01T00:00:00.000Z',
        courseDay: 0,
        workoutTypeID: 0,
        workoutIntensity: 0,
        dailyEvaluation: '',
        hourSelptLastNight: 0,
        moodID: 2,
        appetiteID: 0,
        energyID: 0,
        bodyWeight: 0,
        caloriesExpended: 0,
        trainingItems: [
        ],
        trainingAerobicItems: [],
        id: 0,

        testDateTime : '19700101000000',

weightControl : 0 ,
bfmControl : 0 ,
ffmControl : 0 ,
inBodyScore : 0 ,
targetWeight : 0 ,


weight : 0,
lowerLimitWeightNormalRange: 0,
upperLimitWeightNormalRange: 0,

tbw : 0 ,
lowerLimitTBWNormalRange : 0 ,
upperLimitTBWNormalRange : 0 ,

protein : 0 ,
lowerLimitProteinNormalRange : 0 ,
upperLimitProteinNormalRange : 0 ,

minerals : 0 ,
lowerLimitMineralsNormalRange : 0,
upperLimitMineralsNormalRange : 0,

bfm : 0 ,
lowerLimitBFMNormalRange : 0,
upperLimitBFMNormalRange : 0,

bmi:0,
pbf:0,


ffmOfRightArm:  0,
  ffmPercentOfRightArm: 0,
  ffmOfLeftArm:  0,
  ffmPercentOfLeftArm:  0,
  ffmOfTrunk:  0,
  ffmPercentOfTrunk:  0,
  ffmOfRightLeg: 0,
  ffmPercentOfRightLeg:  0,
  ffmOfLeftLeg: 0,
  ffmPercentOfLeftLeg:  0,

  bfmOfRightArm:  0,
  bfmPercentOfRightArm:  0,
  bfmOfLeftArm:  0,
  bfmPercentOfLeftArm: 0,
  bfmOfTrunk:  0,
  bfmPercentOfTrunk:  0,
  bfmOfRightLeg: 0,
  bfmPercentOfRightLeg:  0,
  bfmOfLeftLeg: 0,
  bfmPercentOfLeftLeg:  0 ,

  bmr : 0 ,
  lowerLimitBMRNormalRange: 0,
  upperLimitBMRNormalRange: 0,
  whr: 0,
  lowerLimitWHRNormalRange: 0,
  upperLimitWHRNormalRange: 0,
  vfl:0 ,
  obesityDegree: 0,
  lowerLimitObesityDegreeNormalRange: 0,
  upperLimitObesityDegreeNormalRange:0,


  kHz20RAImpedance:  0,
  kHz20LAImpedance:  0,
  kHz20TRImpedance:  0,
  kHz20RLImpedance:  0,
  kHz20LLImpedance:  0,
  kHz100RAImpedance:  0,
  kHz100LAImpedance:  0,
  kHz100TRImpedance:  0,
  kHz100RLImpedance:  0,
  kHz100LLImpedance:  0,


      }
    },
  },
})
const {   value, record ,inBodyRecordList  } = toRefs(props)


const colorStyle = {
green :  '#5DF06A',
 red : '#F20707',
 blue : '#1BD3F2',


}

const BCAArray = ref( [
  {
     title :  'Total Body Water',
     subTitle :  'Total amount of water in body',
      range :  '0 ~ 0',
       value : '0',
       unit : 'L',
       icon: icon.Equal ,
       iconStyle : colorStyle.blue,

      },
      {
     title :  'Protein',
     subTitle :  'For building muscles',
     range :  '0 ~ 0',
       value : '0',
       unit : 'kg',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
    },
    {
     title :  'Minerals',
     subTitle :  'For strengthening bones',
     range :  '0 ~ 0',
       value : '0',
       unit : 'kg',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
     title :  'Body Fat Mass',
     subTitle :  'For storing excess energy',
     range :  '0 ~ 0',
      value : '0',
       unit : 'kg',
       icon: icon.Equal,
      },
      {
     title :  'Weight',
     subTitle :  'Sum of the above',
     range :  '0 ~ 0',
      value : '0',
       unit : 'kg',
       icon: icon.Equal
      }
    ])


const MFAArray = ref( [
  {
     title :  'Weight',
     subTitle :  '',
       value : '0',
       unit : 'kg',
       icon : icon.Equal,
       iconStyle : colorStyle.blue,
       percentage : '100%'
      },
      {
        title :  'SMM',
     subTitle :  'Skeletal Muscle Mass',
       value : '0',
       unit : 'kg',
       icon : icon.Equal,
       iconStyle : colorStyle.blue,
       percentage : '100%'
    },
    {
      title :  'Body Fat Mass',
     subTitle :  '',
       value : '0',
       unit : 'kg',
       icon : icon.Equal,
       iconStyle : colorStyle.blue,
       percentage : '100%'

      },

    ])






    const OAArray = ref( [
  {
     title :  'BMI',
     subTitle :  'Body mass ndex',
       value : '0',
       unit : 'kg/m^2',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
     title :  'PBF',
     subTitle :  'Percent body fat',
       value : '0',
       unit : '%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
    ])


    const SLAArray = ref( [
  {
     title :  'Right Arm',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal

      },
      {
     title :  'Left Arm',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,

       icon: icon.Equal
      },
      {
     title :  'Trunk',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
     title :  'Right Leg',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
      title :  'Left Leg',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      }
    ])


    const SFAArray = ref( [
  {
     title :  'Right Arm',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal ,

      },
      {
     title :  'Left Arm',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
     title :  'Trunk',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
     title :  'Right Leg',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      },
      {
      title :  'Left Leg',
       value : '0',
       unit : 'kg',
       percentage : '100%',
       iconStyle : colorStyle.blue,
       icon: icon.Equal
      }
    ])


    const RPArray = ref( [
  {
     title :  'Basal Metabolic Rate',

      range :  '0 ~ 0',
       value : '0',
       unit : 'kcal',

      },
      {
     title :  'Waist-Hi Ratio',

     range :  '0 ~ 0',
       value : '0',
       unit : '',

    },
    {
     title :  'Visceral Fat Level',
     range :  '1 ~ 9',

       value : '0',
       unit : '',

      },
      {
     title :  'Obesity Degree',
     range :  '0 ~ 0',
      value : '0',
       unit : '%',

      },

    ])

  const  IMArray = ref([
      {
     title :  '',
      subTitleFor20 : 'Z(Ω) 20',
      subTitleFor100 : '100',
      unit: 'kHz'
      },


  {
     title :  'RA',
      valueFor20 : '0',
      valueFor100 : '0',
      },
      {
     title :  'LA',
     valueFor20 : '0',
      valueFor100 : '0',
      },
      {
     title :  'TR',
     valueFor20 : '0',
      valueFor100 : '0',
      },
      {
     title :  'RL',
     valueFor20 : '0',
      valueFor100 : '0',
      },
      {
     title :  'LL',
     valueFor20 : '0',
      valueFor100 : '0',
      },


])

const dialog = ref(value.value)

const emits = defineEmits(['input', 'closed', 'prev', 'next'])
watch(dialog, val => {
  console.log('diaryDialog', val)
  emits('input', val)
})

function prev() {
  emits('prev', record.value.testDateTime)
}

function next() {
  emits('next', record.value.testDateTime)
}

function CheckNext( record , inBodyRecordList ) {
 

  let firstID = 0
   
  try{
    firstID = inBodyRecordList[0].id
  }catch(e) {

  }
   
 
  if (record.id == firstID ){
    return false
  } 
  return true
  
}

function CheckPrev( record , inBodyRecordList ) {
  console.log('inBodyRecordList.length',inBodyRecordList.length)
  console.log('inBodyRecordListasd ',inBodyRecordList)

  let finalID = 0

  try{
   finalID = inBodyRecordList[inBodyRecordList.length - 1 ].id
  }catch(e) {

  }
   
  if (record.id == finalID ){
    return false
  } 
  return true
  
}



watch(value, val => {
 console.log('diaryDialog', val)
  dialog.value = val


  BCAArray.value =  mapBACValue(BCAArray.value , record.value)
  MFAArray.value = mapMFAValue(MFAArray.value ,inBodyRecordList.value , record.value)
  OAArray.value = mapOAValue(OAArray.value ,inBodyRecordList.value , record.value)
  SLAArray.value = mapSLAValue(SLAArray.value , record.value)
  SFAArray.value = mapSFAValue(SFAArray.value , record.value)
  RPArray.value = mapRPValue(RPArray.value , record.value)
  IMArray.value = mapIMValue(IMArray.value , record.value)

// console.log('inBodyRecordList' , )

})

watch(record, val => {

 console.log('recordupdate')

  BCAArray.value =  mapBACValue(BCAArray.value , val)
  MFAArray.value = mapMFAValue(MFAArray.value ,inBodyRecordList.value ,val)
  OAArray.value = mapOAValue(OAArray.value ,inBodyRecordList.value ,val)
  SLAArray.value = mapSLAValue(SLAArray.value , val)
  SFAArray.value = mapSFAValue(SFAArray.value , val)
  RPArray.value = mapRPValue(RPArray.value , val)
  IMArray.value = mapIMValue(IMArray.value , val)

// console.log('inBodyRecordList' , )

})


onMounted(() => {
  dialog.value = value.value
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)



})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

</script>
<style scoped>
.summary-day{
  color:blue;
}
.content-text{
  font-size: 9px;
}
.label-blue{
  color:#2D78F0;
}
.label-green{
  color:#96D45A
}
.label-red{
  color:#DA0063;
}

.label-orange{
  color:#F24726;
}
.label-black{
  color:black;
}

.label-small{
  font-size: 9px;
}
.label-title{
  color:blue;
}


.label-gray{
  color:gray;
}

.label-white{
  color:white;
}

.comment-overflow-hidden{
  overflow-x: hidden;
  white-space: nowrap;
}
.abs-icon{
  position: absolute;
  right: 0;
  top: 0;
  /* color: #2D78F0; */
  font-size: 25px;
  background-color:white;
  cursor: pointer;
}

.scroll-list{
  overflow-y: scroll;

  scrollbar-width: thin;
}
.scroll-list::-webkit-scrollbar {
  width: 12px;
  background: transparent;
}
.scroll-list::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background: #b0b0b0;
  border: solid 3px #e6e6e6;
}
</style>
